import { capitalizeFirstLetter } from '../utils';

import type { ComponentResponse } from '../types';

function getComponentTypeLabel(type: ComponentResponse['type']) {
  if (type === 'filtered-list') {
    return 'Filtered List';
  }

  if (type === 'continue-watching') {
    return 'Continue Watching';
  }

  return capitalizeFirstLetter(type);
}

export { getComponentTypeLabel };
